import { Box, Stack, theme } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { UsedBySectionData } from '../types'
import Image from 'next/image'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

/**
 *  Display logos of brands that use flowcode.
 *  This component is used by both variants from FLOWCODE_LANDING_PAGE_BELOW_FOLD_Q1_2022_UPDATES
 *  V1 is white, V2 is black (dark)
 */
//sectionId is used for navigation
const UsedBySection: FC<{ data?: UsedBySectionData; dark?: boolean; sectionId?: string }> = ({
  data,
  dark,
  sectionId
}) => {
  if (!data) return null
  return (
    <Box
      sx={{
        padding: theme.spacing(4),
        width: '100%'
      }}
    >
      <Stack
        direction="column"
        sx={{
          px: '16px',
          mb: { xs: '32px', md: '56px', lg: '96px' },
          maxWidth: '1035px',
          mx: {
            xs: theme.spacing(4),
            md: 'auto'
          },
          p: dark ? { xs: '35px 0px', md: '35px 8px', lg: '55px' } : { xs: '0px' },
          borderRadius: '12px',
          backgroundColor: dark ? theme.palette.primary.dark : theme.palette.primary.light
        }}
        spacing={theme.spacing(8)}
        id={sectionId}
      >
        <PrismicText
          richTextField={data.primary?.subheader}
          fontSize={{ xs: '24px', md: '28px', lg: '32px' }}
          lineHeight={{ xs: '30px', lg: '40px' }}
          variant={data.primary?.subheader_variant ?? 'display/large'}
          maxWidth="866px"
          mx="auto"
          textAlign="center"
          color={dark ? 'primary.white' : 'primary.black'}
        />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(4, 1fr)', md: 'repeat(10, 1fr)' },
            justifyItems: 'center',
            alignItems: 'center'
          }}
        >
          {data.items?.map((item, idx) => (
            <Image
              data-testid={item.logo.alt}
              key={idx}
              width={item.logo.dimensions?.width}
              height={item.logo.dimensions?.height}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain'
              }}
              src={item.logo.url ?? ''}
              alt={item.logo.alt ?? ''}
            />
          ))}
        </Box>
      </Stack>
    </Box>
  )
}

export default UsedBySection
